import { useCurrentWorkspace } from '@/context/current-workspace';
import { useWorkspaceSettingsLink } from '@/hooks/use-workspace-settings-link';
import { useMasqLink } from '@/utils/navigation';
import { useSampleWorkspace } from '@/utils/sample-workspace';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem } from '@customerio/pluma-components/react';
import { IconButton } from '../icon-button';

export function SettingsDropdown() {
  const currentWorkspace = useCurrentWorkspace();
  const { isSampleWorkspace } = useSampleWorkspace();
  const masqLink = useMasqLink();
  const workspaceSettingsLink = useWorkspaceSettingsLink();

  const showSetUpWorkspaceNavItem =
    window.sessionStorage.getItem('showSetUpWorkspaceNavItem') === 'true' && !isSampleWorkspace(currentWorkspace?.id);

  return (
    <>
      <DropdownMenu>
        {(context) => (
          <IconButton
            label="Settings"
            icon="manage"
            ref={context.reference.setReference}
            {...context.reference.getReferenceProps()}
          />
        )}
        <DropdownMenuContent>
          {showSetUpWorkspaceNavItem ? (
            <DropdownMenuItem href={masqLink(`/workspaces/${currentWorkspace?.id}/journeys/home/workspace-setup`)}>
              Set up workspace
            </DropdownMenuItem>
          ) : null}
          <DropdownMenuItem href={masqLink('/settings')}>Account settings</DropdownMenuItem>
          <DropdownMenuItem href={masqLink('/settings/privacy')}>Privacy &amp; Data settings</DropdownMenuItem>
          <DropdownMenuItem href={workspaceSettingsLink(currentWorkspace?.id ?? 'last')}>
            Workspace settings
          </DropdownMenuItem>
          <DropdownMenuItem href={masqLink('/settings/personal')}>Personal settings</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
